<template>
  <div>
    <table>
      <tr>
        <th style="width:150px">진단영역</th>
        <th>진단문항</th>
        <th v-for="i in 5" :key="i" v-html="i"/>
      </tr>
      <tr>
        <th rowspan="3">NCS 훈련과정 이해</th>
        <td>1. 나는 국가직무능력표준(NCS)이 산업현장에서 직무를 수행하기 위해 요구되는 지식·기술·태도 등의 내용을 국가가 체계화한 것임을 알고 있다.</td>
        <td class="score" v-for="(l, i) in labels" :key="i" v-html="l" @click="$emit('check', 0, i)"
            :class="{test: mode, check: answers[0] === i}"/>
      </tr>
      <tr>
        <td>2. 나는 NCS 채용을 통한 기업의 능력중심 인사관리 및 평생경력 관리 지원에 활용하는 것을 알고 있다.</td>
        <td class="score" v-for="(l, i) in labels" :key="i" v-html="l"  @click="$emit('check', 1, i)"
          :class="{test: mode, check: answers[1] === i}"/>
      </tr>
      <tr>
        <td>3. 나는 NCS훈련과정은 훈련생 성취도 평가를 위해 능력단위별 평가를 실시 한다는 사실을 알고 있다.</td>
        <td class="score" v-for="(l, i) in labels" :key="i" v-html="l"   @click="$emit('check', 2, i)"
          :class="{test: mode, check: answers[2] === i}"/>
      </tr>
      <tr>
        <th rowspan="4">훈련과정 이해도<br>(선수학습 및 경력)</th>
        <td>1. 나는 해당 훈련과정과 유사한 과목을 학교에서 수강한 경험이 있다. (전공 유사정도)</td>
        <td class="score" v-for="(l, i) in labels" :key="i" v-html="l"  @click="$emit('check', 3, i)"
          :class="{test: mode, check: answers[3] === i}"/>
      </tr>
      <tr>
        <td>2. 나는 해당 훈련과정과 유사한 훈련과정을 정규교육(학교교육) 과정 이외에 수강했던 경험이 있다.</td>
        <td class="score" v-for="(l, i) in labels" :key="i" v-html="l"  @click="$emit('check', 4, i)"
          :class="{test: mode, check: answers[4] === i}"/>
      </tr>
      <tr>
        <td>3. 나는 해당 훈련과정의 훈련목표를 숙지하고 있다.</td>
        <td class="score" v-for="(l, i) in labels" :key="i" v-html="l"  @click="$emit('check', 5, i)"
          :class="{test: mode, check: answers[5] === i}"/>
      </tr>
      <tr>
        <td>4. 나는 해당 훈련과정 수강을 통해 성취도가 향상되리라 생각된다.</td>
        <td class="score" v-for="(l, i) in labels" :key="i" v-html="l"  @click="$emit('check', 6, i)"
          :class="{test: mode, check: answers[6] === i}"/>
      </tr>
      <tr>
        <th  rowspan="3">교육의지</th>
        <td>1. 나는 훈련과정과 관련된 수업내용에 대한 관심을 가지고 있다.</td>
        <td class="score" v-for="(l, i) in labels" :key="i" v-html="l"  @click="$emit('check', 7, i)"
          :class="{test: mode, check: answers[7] === i}"/>
      </tr>
      <tr>
        <td>2. 나는 훈련과정 수강 중 평가와 관련된 정보를 제공받길 희망한다.</td>
        <td class="score" v-for="(l, i) in labels" :key="i" v-html="l"  @click="$emit('check', 8, i)"
          :class="{test: mode, check: answers[8] === i}"/>
      </tr>
      <tr>
        <td>3. 나는 지각·조퇴·결석 없이 훈련과정을 성실하게 수강한다.</td>
        <td class="score" v-for="(l, i) in labels" :key="i" v-html="l"  @click="$emit('check', 9, i)"
          :class="{test: mode, check: answers[9] === i}"/>
      </tr>
      <tr>
        <th rowspan="2">진단결과</th>
        <th>문항수 / 종합 점수</th>
        <th colspan="5">성취수준(점수 총합/문항 수)</th>
      </tr>
      <tr>
        <td class="text-center">{{answers.length}} / {{total}}</td>
        <td class="text-center" colspan="5">{{score}}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  name: 'PrediagTestQuestion',
  components: {},
  props: ['answers', 'mode'],
  data: () => ({
    labels: ['전혀<br/>모른다', '거의<br/>모른다', '보통<br/>이다', '잘<br/>안다', '매우<br/>잘안다']
  }),
  computed: {
    total () {
      if (!this.answers) return ''
      return this.answers.reduce((acc, c) => {
        acc += c
        return acc
      }, 0)
    },
    score () {
      if (!this.answers) return ''
      return (this.total / this.answers.length).toFixed(1)
    }

  }
}
</script>
<style scoped>
table {
  width: 100%;
  border: 1px solid #444444;
  border-collapse: collapse;
}
th {
  text-align: center;
  font-weight: 900;
  background-color: whitesmoke;
}
th.score {
  width: 70px;
  text-align: center;
  background-color: whitesmoke;
}
td.score {
  width: 70px;
  text-align: center;
  color: lightgray;
}
td.test:hover, td.score.check{
  cursor: pointer;
  width: 70px;
  text-align: center;
  font-weight: 900;
  color: red;
}
th, td {
  border: 1px solid #444444;
  padding: 10px;
}
</style>
